import { render, staticRenderFns } from "./About.vue?vue&type=template&id=42630ebc&scoped=true&lang=pug&"
var script = {}
import style0 from "./About.vue?vue&type=style&index=0&id=42630ebc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42630ebc",
  null
  
)

export default component.exports